import { render, staticRenderFns } from "./topoEdit.vue?vue&type=template&id=ba57465c&scoped=true&"
import script from "./topoEdit.vue?vue&type=script&lang=js&"
export * from "./topoEdit.vue?vue&type=script&lang=js&"
import style0 from "./topoEdit.vue?vue&type=style&index=0&id=ba57465c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba57465c",
  null
  
)

export default component.exports